import { createContext } from "react";
import type useInstitutionIdentityById from "src/hooks/data/load/useInstitutionIdentityById";

export interface IInstitutionIdentityContext extends ReturnType<
    typeof useInstitutionIdentityById
> {}

export const InstitutionIdentityContext = createContext<IInstitutionIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default InstitutionIdentityContext;
